import textPopup from '../views/textAngularPopup.html';
class TeachingPlanController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, TPCONSTANT, $mdMedia, $mdDialog, $stateParams, archiveService, Upload, GOOGLE_CLASSROOM_CONSTANTS, CONSTANTS) {
        let authoringData = localStorageService.get("authoringData")
        //To get current user id
        let userId = localStorageService.get('user_id')
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            if (!authoringData) {
                $state.go("authdashboard")
            } else {
                var reqObj = {
                    session_id: authoringData.session_id,
                    curriculum_id: authoringData.curriculum_id,
                    class_id: authoringData.class_id,
                    batch_id: authoringData.batch_id,
                    subject_id: authoringData.subject_id,
                    school_id: authoringData.school_id,
                    academic_year: authoringData.academic_year,
                    user_id: userId
                }
                authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_GET_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
                    if (response.result && response.result.data && response.result.data.details) {
                        try {
                            $scope.classroomDetails = response.result.data.details
                        } catch (ex) {
                            console.log(ex);
                        }
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        }
        //To get Roles and Privileges
        let tpUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
            return feature.module_state == "teachingPlan"
        })
        let authoring = {
            session_id: authoringData.session_id,
            curriculum_id: authoringData.curriculum_id,
            class_id: authoringData.class_id,
            batch_id: authoringData.batch_id,
            school_id: authoringData.school_id,
            subject_id: authoringData.subject_id,
            academic_year: authoringData.academic_year,
            class: authoringData.class,
            batch: authoringData.batch,
            curriculum: authoringData.curriculum,
            subject: authoringData.subject
        }
        authService.callAPI(TPCONSTANT.API_GET_CURRENT_DATE, "GET", {}, function (response) {
            if (response && response.result && response.result.data) {
                $scope.serverDate = response.result.data.data
                _.defer(function () {
                    $scope.$apply();
                });
            }
        })

        $scope.tpUserPrivilege = {};
        if (tpUserAccess.length > 0) {
            _.each(tpUserAccess, function (tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function (privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.tpUserPrivilege[tpObj.feature_id] = user_access;
            })
        }
        //To get all the resource types
        $scope.resourceTypes = TPCONSTANT.RESOURCES_LABEL
        //Flag for new teaching plan
        $scope.newPlan = true
        //To set privilege for creating resources
        if ($scope.tpUserPrivilege && $scope.tpUserPrivilege.resources && $scope.tpUserPrivilege.resources.create)
            $scope.createResource = true
        if ($scope.tpUserPrivilege && $scope.tpUserPrivilege.visibleToStudent && $scope.tpUserPrivilege.visibleToStudent.create)
            $scope.visibleToStudent = true
        //initializing teaching plan object
        var stat = false
        $scope.errors = {}
        $scope.teachingPlan = {
            "title": "",
            "objectives": "",
            "objectives_status": true,
            "learning_materials": "",
            "knowledge_required_status": true,
            "knowledge_required": "",
            "learning_materials_status": true,
            "teaching_methodology": "",
            "teaching_methodology_status": stat,
            "life_skills": "",
            "life_skills_status": stat,
            "conclusion_status": stat,
            "conclusion": "",
            "formative_assessment_status": stat,
            "formative_assessment": "",
            "resources_including_ICT": [],
            "resources_including_ICT_status": stat,
            "flow_of_tp": "",
            "flow_of_tp_status": stat,
            "other_details": "",
            "other_details_status": stat,
            "remedial_tp": "",
            "remedial_tp_status": stat,
            "resources": [],
            "status": "",
            "start_date": "",
            "end_date": "",
            "academic_year": ""

        };
        //Object: Teachingplan resources
        $scope.resource = {}
        $scope.isEdit = false

        //To get theme name
        let planDetails = localStorageService.get('plan_details')
        if (planDetails) {
            $scope.themeName = planDetails.theme_name
            $scope.teachingPlan.title = planDetails.plan_name
        }
        //Popup for text angular editor window
        $scope.viewTextAngular = function (obj, teachingPlan) {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                locals: {
                    teachingPlan: teachingPlan
                },
                template: textPopup,
                controller: ['$scope', '$mdDialog', 'teachingPlan',
                    function ($scope, $mdDialog) {
                        $scope.tp = {}
                        $scope.teachingPlan = teachingPlan
                        if ($scope.teachingPlan[obj])
                            $scope.tp[obj] = $scope.teachingPlan[obj].toString()
                        let nameobj = [
                            {
                                _id: "objectives",
                                name: "OBJECTIVES"
                            }, {
                                _id: "knowledge_required",
                                name: "REQUIRED KNOWLEDGE"
                            }, {
                                _id: "learning_materials",
                                name: "REQUIRED LEARNING MATERIALS"
                            }, {
                                _id: "teaching_methodology",
                                name: "REQUIRED TEACHING METHODOLOGY"
                            }, {
                                _id: "life_skills",
                                name: "REQUIRED LIFE SKILLS"
                            }, {
                                _id: "conclusion",
                                name: "REQUIRED CONCLUSION"
                            }, {
                                _id: "formative_assessment",
                                name: "REQUIRED FORMATIVE ASSESSMENT"
                            }, {
                                _id: "flow_of_tp",
                                name: "FLOW OF TEACHING PLAN"
                            }, {
                                _id: "remedial_tp",
                                name: "REMEDIAL TEACHING PLAN"
                            }, {
                                _id: "other_details",
                                name: "OTHER DETAILS"
                            }
                        ]
                        _.each(nameobj, function (name) {
                            if (name._id == obj)
                                $scope.popupTitle = name.name

                        })


                        $scope.reqObj = obj
                        $scope.saveContent = function () {
                            $scope.teachingPlan[obj] = $scope.tp[obj]
                            $mdDialog.hide();
                        }
                        $scope.closeEditor = function () {
                            $mdDialog.hide();
                        }
                    }
                ],
                parent: angular.element(document.body),
                // clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
        }

        $scope.getTeachingPlan = (planId) => {
            authService.callAPI(TPCONSTANT.API_GET_TP + planId + "/" + userId, "GET", {}, function (response) {
                if (response && response.result && response.result.data) {
                    $scope.teachingPlan = response.result.data
                    $scope.themeName = $scope.teachingPlan.theme_title
                    $scope.resource.file = $scope.teachingPlan.resources
                    if ($scope.teachingPlan.teacher_id === userId)
                        $scope.isCreator = true
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            })
        }
        $scope.getTeachingPlanFromArchive = (planId) => {
            authService.callAPI(TPCONSTANT.API_GET_TP + planId + "/" + userId, "GET", {}, function (response) {
                if (response && response.result && response.result.data) {
                    $scope.teachingPlan = response.result.data
                    $scope.themeName = $scope.teachingPlan.theme_title
                    $scope.resource.file = $scope.teachingPlan.resources
                    _.each($scope.teachingPlan.resources, function (resource) {
                        if (resource.status)
                            resource.status = "created";
                        resource.assign_users = {};
                        resource.current_approver = {};
                        resource.isComplete = false;
                    })
                    if ($scope.teachingPlan.teacher_id === userId)
                        $scope.isCreator = true
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            })
        }
        let redirectDetails = archiveService.getRedirectJson();
        archiveService.clearRedirectJson();
        if (redirectDetails && redirectDetails.returnData) {
            let planId = redirectDetails.returnData.resource._id
            $scope.getTeachingPlanFromArchive(planId)
            $scope.isFromArchive = true;
            /*Meteor.call("getTeachingPlan", planId, (error, teachingPlan) => {
                if (error) {
                    toastr.error("Network Error, please try later.")
                } else {
                    $scope.teachingPlan = teachingPlan
                    _.each(teachingPlan.resources, function(resource) {
                        if (resource.status)
                            resource.status = STATUS_CREATED;
                        resource.assign_users = {};
                        resource.current_approver = {};
                        resource.isComplete = false;
                    })
                    $scope.resource = {
                        file: teachingPlan.resources
                    }
                    $scope.isFromArchive = true;
                    $scope.$apply()
                }
            })*/
        }
        if ($stateParams.planId) {
            $scope.newPlan = false
            $scope.getTeachingPlan($stateParams.planId)
            $scope.isEdit = true
        }
        $scope.save = (tpStatus) => {
            console.log($scope.teachingPlan)
            authoring['theme_name'] = $scope.themeName
            authoring['theme_id'] = $state.params.id
            $scope.teachingPlan.resources = angular.copy($scope.resource.file)
            let tpError = 0
            //validation
            // $scope.resource.file.forEach(element => {
                
            // });
            $scope.errors.resourcefile=[]
            for(let eachresource in $scope.resource.file){
                for(let each in $scope.resource.file){
                    if($scope.resource.file[eachresource].type && $scope.resource.file[eachresource].title && eachresource!=each && ($scope.resource.file[eachresource].title===$scope.resource.file[each].title)&&($scope.resource.file[eachresource].type===$scope.resource.file[each].type)){
                        $scope.errors.resourcefile[each] = "Duplicate value for same resource"
                        tpError++
                    }
                }
            }
            if (tpStatus === "draft" || tpStatus === "created") {
                if ($scope.teachingPlan.title === "" || $scope.teachingPlan.title === undefined || $scope.teachingPlan.title === null) {
                    $scope.errors['title'] = "Teaching plan name required"
                    tpError++
                }
            }
            if (tpStatus === "created") {
                if ($scope.teachingPlan.objectives === "" || $scope.teachingPlan.objectives === undefined || $scope.teachingPlan.objectives === null) {
                    $scope.errors['objectives'] = "Objectives required"
                    tpError++
                }
                if ($scope.teachingPlan.learning_materials === "" || $scope.teachingPlan.learning_materials === undefined || $scope.teachingPlan.learning_materials === null) {
                    $scope.errors['learning_materials'] = "Learning materials required"
                    tpError++
                }
                if ($scope.teachingPlan.knowledge_required === "" || $scope.teachingPlan.knowledge_required === undefined || $scope.teachingPlan.knowledge_required === null) {
                    $scope.errors['knowledge_required'] = "Knowledge required"
                    tpError++
                }
                if ($scope.teachingPlan.start_date === "" || $scope.teachingPlan.start_date === undefined || $scope.teachingPlan.start_date === null) {
                    $scope.errors['start_date'] = "Start date required"
                    tpError++
                }
                if ($scope.teachingPlan.end_date === "" || $scope.teachingPlan.end_date === undefined || $scope.teachingPlan.end_date === null) {
                    $scope.errors['end_date'] = "End date required"
                    tpError++
                }
            }
            $scope.errors.resources = [];
            _.each($scope.teachingPlan.resources, function (eachResource, index) {
                $scope.errors.resources.push({
                    title: '',
                    type: ''
                });
                if (eachResource.title === undefined || eachResource.title === null || eachResource.title === '') {
                    $scope.errors.resources[index].title = 'Resource Title is required';
                    tpError++;
                }
                if (eachResource.type === undefined || eachResource.type === null || eachResource.type === '') {
                    $scope.errors.resources[index].type = 'Resource Type is required';
                    tpError++;
                }
            })
            if (tpError === 0) {
                if ($scope.isEdit) {
                    let tpObj = {
                        authoring: authoring,
                        user_id: userId,
                        teaching_plan: $scope.teachingPlan,
                        status: tpStatus,
                        tp_id: $stateParams.planId
                    }
                    authService.callAPI(TPCONSTANT.API_UPDATE_TP, "POST", tpObj, function (response) {
                        if (response && response.result && response.result.data) {
                            $rootScope.updateSidenav()
                            let planId = response.result.data.details
                            toastr.success('Teaching Plan updated successfully')
                            if ($scope.resource && $scope.resource.file && $scope.resource.file.length > 0) {
                                $state.go('wizard', {
                                    "planId": $stateParams.planId
                                })
                            } else {
                                $state.go('viewTeachingPlan', {
                                    "planId": $stateParams.planId
                                });
                            }

                            _.defer(function () {
                                $scope.$apply();
                            });
                        }
                    })
                } else {
                    if ($scope.isFromArchive) {
                        let tpObj = {
                            authoring: authoring,
                            user_id: userId,
                            teaching_plan: $scope.teachingPlan,
                            status: tpStatus
                        }
                        console.log(tpObj)
                        authService.callAPI(TPCONSTANT.API_SELECT_TP, "POST", tpObj, function (response) {
                            if (response && response.result && response.result.data) {
                                console.log(response)
                                if (response.result.data.details) {
                                    if (response.result.data.details.planId) {
                                        let planId = response.result.data.details.planId
                                        $rootScope.updateSidenav()
                                        if ($scope.resource && $scope.resource.file && $scope.resource.file.length > 0) {
                                            $state.go('wizard', {
                                                "planId": planId
                                            })
                                        } else {
                                            $state.go('viewTeachingPlan', {
                                                "planId": planId
                                            });
                                        }
                                    } else {
                                        toastr.error(response.result.data.details.msg)
                                    }
                                }

                                _.defer(function () {
                                    $scope.$apply();
                                });
                            }
                        })
                    } else {

                        let tpObj = {
                            authoring: authoring,
                            user_id: userId,
                            teaching_plan: $scope.teachingPlan,
                            status: tpStatus
                        }
                        console.log(tpObj)
                        authService.callAPI(TPCONSTANT.API_CREATE_TP, "POST", tpObj, function (response) {
                            if (response && response.result && response.result.data) {
                                if (response.result.data.details) {
                                    $rootScope.updateSidenav()
                                    let planId = response.result.data.details
                                    toastr.success('Teaching Plan created successfully')
                                    if ($scope.resource && $scope.resource.file && $scope.resource.file.length > 0) {
                                        $state.go('wizard', {
                                            "planId": planId
                                        })
                                    } else {
                                        $state.go('viewTeachingPlan', {
                                            "planId": planId
                                        });
                                    }
                                }

                                _.defer(function () {
                                    $scope.$apply();
                                });
                            }
                        })
                    }
                }
            } else {
                toastr.error("Please fill all mandatory field")
            }
        }
        // To delete resource
        $scope.deleteResource = (index) => {
            $scope.resource.file.splice(index, 1)
        }
        // To add new resource
        $scope.addNewResource = (resource, index) => {
            if (!$scope.resource.file) {
                $scope.resource.file = []
            }
            $scope.resource.file.push({
                "type": null,
                "title": null,
                "isPractice": false
            })
        }
        //To set default title for each resource
        $scope.setDefaultTitle = function (dataObj, curResIndex, isPractice) {
            let pracCount = 0
            let assCount = 0
            _.each($scope.resource.file, function (res) {
                if (res.type === "activityForm") {
                    if (res.isPractice)
                        pracCount++
                    else
                        assCount++
                }
            })
            //Number - Index for default title
            let index;
            //String - type of resource
            let type = dataObj.type
            //[Object] - Same type resources
            let sameRes = _.filter($scope.resource.file, function (res) {
                return res.type === type
            })
            index = sameRes.length;
            if (type === "activityForm") {
                if (isPractice)
                    dataObj['title'] = TPCONSTANT.RESOURCES_TITLE["practice"] + " " + pracCount;
                else
                    dataObj['title'] = TPCONSTANT.RESOURCES_TITLE["assessment"] + " " + assCount;
            } else {
                dataObj['title'] = TPCONSTANT.RESOURCES_TITLE[type] + " " + index
            }
        }
        //To show user assign screen
        $scope.showAssignUser = () => {
            if ($scope.isUserAssigned) {
                var confirm = $mdDialog.confirm()
                    .textContent('It will reassign previously assigned students of all resources and activities')
                    .ok('Ok')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function () {
                    $state.go('assignUsers', {
                        planId: $state.params.planId,
                        previousState: {
                            state: 'newTeachingPlan',
                            params: $stateParams
                        }
                    })
                }, function () { });
            } else {
                $state.go('assignUsers', {
                    planId: $state.params.planId,
                    previousState: {
                        state: 'newTeachingPlan',
                        params: $state.params
                    }
                })
            }
        }
        $scope.gotoOverviewPage = () => {
            if ($scope.isEdit)
                $state.go('viewTeachingPlan', {
                    planId: $stateParams.planId
                })
            else
                $state.go('authoringTool')
        }
        $scope.selectFromArchive = () => {

            let teachingPlan = $scope.teachingPlan;
            let searchFilters = [];
            searchFilters.push({
                type: "tab",
                value: {
                    _id: "teachingPlan",
                    name: "Plans"
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: "theme",
                value: {
                    _id: $state.params.id,
                    name: $scope.themeName
                },
                deletable: false,
                visible: true
            });
            let details = {
                searchFilters: searchFilters,
                previousState: {
                    state: $state.current.name,
                    params: $state.params
                },
                isMultiSelect: false,
                activeTab: 'teachingPlan',
                resourceType: {
                    _id: "teachingPlan",
                    name: "Plans"
                }
            }
            archiveService.setRedirectJson(details)
            $state.go("archives");
        }

        $scope.getClassroomTopics = function () {
            $scope.isLoading = true;
            var reqObj = {
                course_id: $scope.classroomDetails._id,
                teacher_email: localStorageService.get('username'),
                school_id: authoringData.school_id
            }
            authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_GET_CLASSROOM_TOPICS, 'POST', reqObj, function (response) {
                $scope.isLoading = false;
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.topics = response.result.data.details.topic;
                    if ($scope.topics) {
                        $mdDialog.show({
                            controller: DialogController,
                            template: '<md-dialog>' +
                                '<md-toolbar>' +
                                '<div class="md-toolbar-tools">' +
                                '<h2>Select Teaching Plan</h2>' +
                                '<span flex></span>' +
                                '<md-button class="md-icon-button" ng-click="cancel()">' +
                                '<i class="fas fa-times"></i>' +
                                '</md-button>' +
                                '</div>' +
                                '</md-toolbar>' +
                                '<md-dialog-content>' +
                                '<div class="md-dialog-content">' +
                                '<div ng-repeat="topic in topics" ng-click="selectTeachingPlan(topic)">' +
                                '<p>{{topic.name}}</p>' +
                                '</div>' +
                                '</div>' +
                                '</md-dialog-content>' +
                                '</md-dialog>',
                            parent: angular.element(document.body),
                            topics: $scope.topics,
                            clickOutsideToClose: true
                        }).then(function (topic) {
                            $scope.isLoading = true;
                            $scope.importFromClassroom(topic);
                        });
                    } else {
                        toastr.error('No Topics are added for this Course in Google Classroom');
                    }
                } else {
                    $scope.isLoading = false;
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.importFromClassroom = function (topic) {
            var reqObj = {
                topic_details: topic,
                teacher_id: userId,
                teacher_email: localStorageService.get('username'),
                academic_details: {
                    session_id: authoringData.session_id,
                    curriculum_id: authoringData.curriculum_id,
                    class_id: authoringData.class_id,
                    batch_id: authoringData.batch_id,
                    subject_id: authoringData.subject_id,
                    session: authoringData.session,
                    curriculum: authoringData.curriculum,
                    class: authoringData.class,
                    batch: authoringData.batch,
                    subject: authoringData.subject,
                    school_id: authoringData.school_id,
                    academic_year: authoringData.academic_year,
                    theme_id: $state.params.id,
                    theme_title: $scope.themeName
                }
            }
            $scope.isLoading = true;
            authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_IMPORT_FROM_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
                $scope.isLoading = false;
                if (response.result && response.result.data && response.result.data.details) {
                    let planId = response.result.data.details._id;
                    toastr.success('Teaching Plan created successfully');
                    if (response.result.data.details.is_resource_exists) {
                        $state.go('wizard', {
                            planId: planId
                        });
                    } else {
                        $state.go('viewTeachingPlan', {
                            planId: planId
                        });
                    }
                } else {
                    $scope.isLoading = false;
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        this.$onDestroy = () => {

        }
    }
}

function DialogController($scope, $mdDialog, topics) {
    $scope.topics = topics;
    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.selectTeachingPlan = function (topicId) {
        $mdDialog.hide(topicId);
    };
}

export default TeachingPlanController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/teachingPlan/controllers/createTeachingPlanController.js